<div class="container">
  <div class="head">
    <div class="head-label" mat-dialog-title>
      {{ data.title }}
    </div>
    <mat-icon class="head-exit" mat-dialog-close="">close</mat-icon>
  </div>

  <div class="content">
    <div *ngIf="!isLoading; else loader">
      <div *ngFor="let product of data.modifiers">
          <div class="selectable-dish">
            <mat-checkbox (change)="handleCheckProduct(product, $event.checked)"
                          [checked]="isSelectedProduct(product)"
                          [matTooltip]="'MENU.IS_NOT_ACTIVE_DISH' | translate"
                          class="selectable-dish-checkbox"
                          matTooltipPosition="right"
            >
            </mat-checkbox>
            <div style="flex-grow: 1">
              <div>{{product.name}}</div>
              <div>{{product.description}}</div>
              <div>SKU: {{product.sku}}</div>
            </div>
          </div>
      </div>
    </div>
    <ng-template #loader>
      <div>
        {{ 'COMMON.LOADING' | translate }}
      </div>
    </ng-template>
  </div>
  <button (click)="save()"
          class="submit-button"
          color="primary"
          mat-raised-button
          matTooltipPosition="left">{{ 'COMMON.SAVE' | translate }}</button>
</div>
